import React from 'react';
import cx from 'classnames';

import styles from './PaginationNumberField.module.scss';
import { PaginationNumberFieldProps } from './PaginationNumberField.types';
import usePresenter from './PaginationNumberField.presenter';

const PaginationNumberField = (props: PaginationNumberFieldProps) => {
  const { inputRef, page, onBlur, onPageChanged, keyListener } = usePresenter(props);
  return (
    <div className={cx(styles.root, props.className)}>
      <input
        className={styles.pageNumber}
        ref={inputRef}
        value={page}
        onChange={onPageChanged}
        onKeyUp={keyListener}
        onBlur={onBlur}
      />
    </div>
  );
};

export default PaginationNumberField;
